export default "__VITE_ASSET__DZ7mb6AD__"